import logo from '../assets/logo.svg'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

function Header() {
    const actualLocation = useLocation()
	return (
        <header>
            <div className='kasaLogo'>
                <Link to='/'>
                    <img src={logo} alt='Logo de Kasa' />
                </Link>
            </div>
            <nav>
                <ul className='desktop'>
                    <li>{actualLocation.pathname === '/' ? <Link to='/'><span className='actualLocation'>Accueil</span></Link> : <Link to='/'>Accueil</Link>}</li>
                    <li>{actualLocation.pathname === '/a-propos' ? <Link to='/a-propos'><span className='actualLocation'>A Propos</span></Link> : <Link to='/a-propos'>A Propos</Link>}</li>
                </ul>
            </nav>
        </header>
    )
}

export default Header
